import { conditionalField } from './forms';

/** ****************************** */
/** *********** Fields *********** */
/** ****************************** */

function calculateSubtotalFxG(fxgEls, subtotalEl) {
  let subtotal = 0;
  fxgEls.each(function accumulateSumFxG1() {
    if ($(this).val()) {
      subtotal += parseInt($(this).val());
    }
  });

  if (subtotal) {
    $(subtotalEl).val(subtotal);
  } else {
    $(subtotalEl).val('');
  }
}

export function calculateFxGFields() {
  /**
   * Calculate all NPI ES Frequencies x Gravities, including subtotal and total sums.
   */
  const frequencies = $('.npi_es_frequency');
  const gravities = $('.npi_es_gravity');
  const fxg = $('.npi_es_fxg');

  frequencies.each(function multiplyFrequencyGravity(index) {
    const frequency = $(frequencies[index]).val();
    const gravity = $(gravities[index]).val();
    let result = '';

    if (frequency && gravity) {
      result = parseInt(frequency) * parseInt(gravity);
    }

    $(fxg[index]).val(result);
  });

  // Calculate subtotals and total.
  const prefix = '#consultation-79_psycho_network\\/';
  const subtotalEl1 = $(`${prefix}npi_es-fxg_subtotal_1`);
  const subtotalEl2 = $(`${prefix}npi_es-fxg_subtotal_2`);

  calculateSubtotalFxG($('.npi_es_fxg-1'), subtotalEl1);
  calculateSubtotalFxG($('.npi_es_fxg-2'), subtotalEl2);

  const subtotal1 = subtotalEl1.val() ? parseInt(subtotalEl1.val()) : 0;
  const subtotal2 = subtotalEl2.val() ? parseInt(subtotalEl2.val()) : 0;
  const total = subtotal1 + subtotal2;

  if (total) {
    $(`${prefix}npi_es-fxg_total`).val(total);
  } else {
    $(`${prefix}npi_es-fxg_total`).val('');
  }
}

$(document).on('click', '.buttonGroup-button', function handleButtonGroup() {
  /**
   * Manage NPI ES button groups.
   */
  const inputData = $(this).data('input');
  const escapedInputId = inputData.replace('/', '\\/');
  const input = $(`#${escapedInputId}`);
  const value = $(this).data('value');

  if ($(this).hasClass('btn-primary')) {
    $(this).removeClass('btn-primary').addClass('btn-default');
    input.val('');
  } else {
    $(`[data-input="${inputData}"]`).removeClass('btn-primary').addClass('btn-default');
    $(this).removeClass('btn-default').addClass('btn-primary');
    input.val(value);
  }

  $(this).trigger('blur');

  conditionalField(input);

  // If entering any frequency, gravity or impact level, presence field has to be updated.
  if (escapedInputId.endsWith('_frequency') || escapedInputId.endsWith('_gravity') || escapedInputId.endsWith('_impact_level')) {
    const flexPage = $(this).closest('.flex-page');
    const presenceField = $(`#${escapedInputId.replace('_frequency', '').replace('_gravity', '').replace('_impact_level', '')}`);
    if (flexPage.find('.btn-primary').length && !flexPage.find('[disabled]').length) {
      presenceField.val(true);
    } else {
      presenceField.val('');
    }
  }

  if (input.hasClass('npi_es_presence') ||
    input.hasClass('npi_es_frequency') ||
    input.hasClass('npi_es_gravity')) {
    calculateFxGFields();
  }
});

function calculateRadioScore(inputClass, totalInputId) {
  /**
   * Calculate total score from radio inputs having 'inputClass' as class name and inject it on the relevant text input.
   * Radio inputs have the following label format: '<associated numeric score> : label'.
   */
  const inputFields = $(`.${inputClass}`);
  let total = null;

  inputFields.each(function accumulateD17Score() {
    if ($(this).prop('checked')) {
      if (total === null) {
        total = 0;
      }
      const splitValue = $(this).val().split(' :');
      if (splitValue) {
        total += parseInt(splitValue[0]);
      }
    }
  });

  const totalEl = $(`#${totalInputId}`);
  totalEl.attr('readonly', false);
  if (total !== null) {
    totalEl.val(total);
  } else {
    totalEl.val('');
  }

  totalEl.attr('readonly', true);
}

export function calculateHamD17Score() {
  calculateRadioScore('ham_d17', 'consultation-79_psycho_network\\/ham_d17-total');
}
$(document).on('click', '.ham_d17', calculateHamD17Score);

export function calculateNeurologicalDisorderTotal() {
  calculateRadioScore('neurological_disorder_score', 'consultation-79_teleregulation\\/neurological_signs-neurological_disorder_score_total');
}
$(document).on('click', '.neurological_disorder_score', calculateNeurologicalDisorderTotal);

export function calculateAllConsultationFields() {
  /**
   * Calculate all fields which can be present on a consultation's page.
   * Useful when opening a draft.
   */
  calculateFxGFields();
  calculateHamD17Score();
  calculateNeurologicalDisorderTotal();


  const handledRadioNames = new Set(); // Evaluate each radio group once, even when no option is checked.

  $('input[type=radio]').each(function handleConditionalField() {
    const radioName = $(this).prop('name');
    if (handledRadioNames.has(radioName)) {
      return;
    }
    handledRadioNames.add(radioName);
    conditionalField($(this));
  });
  $('input, select').not(':input[type=radio]').each(function handleConditionalField() {
    conditionalField($(this));
  });
}

/** ****************************** */
/** ********** Patients ********** */
/** ****************************** */

function hideOption(divId) {
  const div = $(divId);
  const select = div.children('select');

  const firstValue = select.find('option:first-child').val();
  select.val(firstValue).trigger('change');
  select.removeAttr('name');
  select.removeProp('required');

  div.addClass('hidden');
}

function showOption(divId) {
  const div = $(divId);
  const select = div.children('select');

  select.attr('name', select.attr('id'));
  select.prop('required', true);

  div.removeClass('hidden');
}

export function manageExistingPatient() {
  /**
   * Manage patient type field behavior and display patient selector if existing patient.
   * Also called when loading consultation fields from localStorage.
   */
  const patientType = $('input[name=patient-patient_type]:checked');

  if (patientType.val() === 'existing') {
    hideOption('#patient-anonymous_patient');
    showOption('#patient-existing_patient');
  } else {
    hideOption('#patient-existing_patient');
    showOption('#patient-anonymous_patient');
  }
}
$(document).on('click', 'input[name=patient-patient_type]', manageExistingPatient);

$(document).on('click', '[data-recipients-add-participants]', function addParticipants() {
  const selectID = $(this).data('recipients-add-participants').replace('/', '\\/');
  $(`#${selectID}`)
    .find('option.participant').prop('selected', true).end()
    .trigger('change');
});

$(document).on('click', '[data-recipients-add-medcos]', function addMedcos() {
  const selectID = $(this).data('recipients-add-medcos').replace('/', '\\/');
  const select = $(`#${selectID}`);

  for (const option of $(this).prev('#comment-medcos').find('option')) {
    const existingOption = select.find(`option[value="${option.value}"]`);
    if (existingOption.length) {
      existingOption.addClass('medco');
    } else {
      option.setAttribute('selected', true);
      select.append(option);
    }
  }

  select.find('option.medco').prop('selected', true).end();
  select.trigger('change');
});

/** ****************************** */
/** ************ MSF ************* */
/** ****************************** */

// Do not download images before preview.
$(document).on('click', 'a[data-toggle=modal][data-src]', function setPreviewSource() {
  const modalID = $(this).data('target');
  const image = $(modalID).find('img');
  if (image.length) {
    image.attr('src', $(this).data('src'));
  }
});

// Autoplay videos in modals.
$(document).on('click', 'a[data-toggle=modal]', function autoPlayVideo() {
  const modalID = $(this).data('target');
  const video = $(modalID).find('video');
  if (video.length) {
    video[0].play();
  }
});

// Pause video on modal close.
$(document).on('hide.bs.modal', function pauseVideo(event) {
  const video = $(event.target).find('video');
  if (video.length) {
    video[0].pause();
  }
});

export function getMSFCaseStatus(form) {
  /**
   * Move MSF forms.
   */
  document.querySelectorAll('.msf-status').forEach(msfStatusForm => {
    ['input', 'select'].forEach(tagName => {
      Array.prototype.forEach.call(msfStatusForm.getElementsByTagName(tagName), input => {
        form.appendChild(input);
        input.classList.add('hidden');
      });
    });
  });
}

export function validateMSFCaseStatus() {
  /**
   * Pre-validate MSF case special fields elements.
   */
  let validated = true;

  document.querySelectorAll('.msf-status').forEach(form => {
    // If any form is invalid, keep that value.
    validated = validated && form.reportValidity();
  });

  return validated;
}
